export const CITY_FILTER_KEY = 'city'
export const DISTANCE_FILTER_KEY = 'distance'
export const RELOCATION_FILTER_KEY = 'relocation'
export const MANAGER_FILTER_KEY = 'manager'
export const TYPE_FILTER_KEY = 'type'
export const UNIVERSE_FILTER_KEY = 'universe'
export const MY_APPLICATION_FILTER_KEY = 'onlyMyAnswers'
export const NB_YEAR_OF_EXPERIENCE_FILTER_KEY = 'nbYearOfExperience'
export const AVAILABILITY_FILTER_KEY = 'availability'
export const LANGUAGE_FILTER_KEY = 'languages'
export const SECTEUR_FILTER_KEY = 'secteur'
export const IT_SKILLS_FILTER_KEY = 'itSkills'
export const PRICE_MIN_FILTER_KEY = 'priceMin'
export const PRICE_MAX_FILTER_KEY = 'priceMax'